import React, { useState, Fragment } from 'react';
import isEmail from 'validator/lib/isEmail';
import useMount from 'react-use/lib/useMount';
import qs from 'qs';
import { isEmpty } from 'lodash-es';

import { Alert, Button, Input } from 'chaoskit/src/components';

const NewsletterForm = ({ ...props }) => {
  const [errors, setErrors] = useState({});
  const [inputs, setInputs] = useState({});
  const [isLoading, setLoading] = useState(false);
  const [response, setResponse] = useState();

  const formId = 'breaking-news';

  useMount(() => {
    if (document.referrer) setInputs({ referrer: document.referrer });

    // If we have query params, add them to inputs that will be sent to Netlify
    const params = qs.parse(window.location.search, {
      ignoreQueryPrefix: true,
    });

    if (!isEmpty(params))
      setInputs(currentInputs => ({ ...currentInputs, ...params }));
  });

  const handleChange = (name, value) => {
    setInputs(currentInputs => ({ ...currentInputs, [name]: value }));
  };

  const encode = data =>
    Object.keys(data)
      .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`)
      .join('&');

  const validateForm = () => {
    const formErrors = {};

    if (!inputs.email || (inputs.email && !isEmail(inputs.email)))
      formErrors.email = 'Valid email is required';

    return formErrors;
  };

  const handleFormSubmission = () => {
    const formErrors = validateForm();

    if (!isEmpty(formErrors)) {
      setErrors(formErrors);

      return;
    }

    // Otherwise clear errors and submit form
    setErrors({});
    setLoading(true);

    fetch('', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: encode({ 'form-name': formId, ...inputs }),
    })
      .then(() => {
        if (window.gtag) {
          window.gtag('event', 'Submit', {
            event_category: ' Subscribe to Newsletter',
            event_label: 'Subscribe to Newsletter - Footer',
          });
        }

        if (window.clearbit) {
          window.clearbit.identify(inputs.email, { email: inputs.email });
        }

        setLoading(false);
        setResponse('success');
      })
      .catch(() => {
        setLoading(false);
        setResponse('error');
      });
  };

  return (
    <Fragment>
      {response === 'success' && (
        <Alert type="primary">
          Thanks for subscribing to Breaking News! 📨 Please check your email to
          confirm your subscription.
        </Alert>
      )}

      {response === 'error' && (
        <Alert type="error">
          There was an error submitting your subscription. Please try again
          later.
        </Alert>
      )}
      {!response && (
        <form
          name={formId}
          method="post"
          data-netlify="true"
          data-netlify-honeypot="bot-field"
          {...props}
        >
          <input type="hidden" name="form-name" value={formId} />
          <input
            name="bot-field"
            className="u-hidden"
            onChange={e => handleChange(e.target.name, e.target.value)}
          />
          <div className="footer__subscribe-fields">
            <div>
              <Input
                required
                onChange={handleChange}
                validationMessage={errors.email}
                name="email"
                type="email"
                placeholder="Email Address"
              />
            </div>
            <div>
              <Button
                loading={isLoading}
                onClick={handleFormSubmission}
                type="primary"
                noContrast
              >
                Subscribe
              </Button>
            </div>
          </div>
        </form>
      )}
    </Fragment>
  );
};

export default NewsletterForm;
